module.exports = __webpack_public_path__ + "img/a66.eb3f1e90.png";